var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.blog.id)?_c('v-card',{staticClass:"mx-auto"},[_c('v-img',{attrs:{"src":_vm.blog.photo
          ? _vm.apiDomain + _vm.blog.photo
          : 'https://cdn.vuetifyjs.com/images/cards/sunshine.jpg',"height":"200px"}}),_c('v-card-title',{domProps:{"textContent":_vm._s(_vm.blog.title)}}),_c('v-card-subtitle',[_vm._v(" "+_vm._s(_vm.blog.description)+" ")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }